import { Component, EventEmitter, forwardRef, Input, OnInit, Optional, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { QuestionAnswer } from 'src/app/modal/questionnaire.models';
import { InputNumberModule } from 'primeng/inputnumber';
import { ProductService } from 'src/app/services/product.service';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NfpBaseInputControlComponent } from '../nfp-base-input-ctrl/nfp-base-input-ctrl.component';

@Component({
  selector: 'nfp-textbox-question',
  templateUrl: './nfp-textbox-question.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None,
  host: { class: 'row mb-1' },  
  providers: [   {
        provide: NG_VALUE_ACCESSOR,
        multi:true,
        useExisting: forwardRef(() =>NfpTextboxQuestionComponent),
      }]
})
export class NfpTextboxQuestionComponent extends NfpBaseInputControlComponent   {
     
    constructor() {
        super();
    }
    
    onValueChanged(evt: any)
    {      
      this.value = evt.target.value;      
    }

    ngOnInit() {
     super.ngOnInit();
    }
}

